import { MultiDynamicOptionsCreatorFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { IFilterHelperFactory } from '../filter-factory.types';

class DynamicCreatorFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: MultiDynamicOptionsCreatorFilter) {}

  getChipLabel() {
    return 'creator filter';
  }

  getFriendlyLabel(): string {
    return 'creator filter';
  }

  hasValue() {
    const { hookArgs } = this.filter.multiDynamicOptionsCreatorArgs;
    const hasId = hookArgs?.defaultValues;

    if (!hasId) {
      return false;
    }

    return Array.isArray(hasId) ? hasId.length > 0 : hasId.trim().length > 0;
  }

  isLoading() {
    return false;
  }
}

export default DynamicCreatorFilterHelper;
